import { useNamespaces } from '../../context/NamespacesContext';
import { useLoopItem } from '../../context/LoopItemContext';
import { RenderElement } from '../../renderer/renderElement';
import { evaluateCondition } from './operators/evaluateCondition';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const If = ({
  element,
  mutableContext,
  onMutableContextChange
}) => {
  var _element$else;
  const namespaces = useNamespaces();
  const loopItem = useLoopItem();
  const activeChildren = evaluateCondition(element.condition, namespaces, loopItem) ? element.children : (_element$else = element.else) !== null && _element$else !== void 0 ? _element$else : [];
  return /*#__PURE__*/_jsx(_Fragment, {
    children: activeChildren.map((child, index) => /*#__PURE__*/_jsx(RenderElement, {
      element: child,
      mutableContext: mutableContext,
      onMutableContextChange: onMutableContextChange
    }, index))
  });
};
export default If;